import type { ISerialize } from '@/objects/ISerialize';
import type { StatusCode } from './../enums/StatusCode';

export class StatusLoaderStatus implements ISerialize {
    public readonly AverageTimePrItem: number | null;

    public readonly Current: number;

    public readonly ElapsedTime: number | null;

    public readonly Failed: number;

    public readonly Status: string | null;

    public readonly StatusCode: StatusCode;

    public readonly Total: number;

    public readonly UserID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        AverageTimePrItem?: number | null;
        Current?: number;
        ElapsedTime?: number | null;
        Failed?: number;
        Status?: string | null;
        StatusCode?: StatusCode;
        Total?: number;
        UserID?: number;
    }) {
        this.AverageTimePrItem = values.AverageTimePrItem ?? null;

        this.Current = values.Current ?? 0;

        this.ElapsedTime = values.ElapsedTime ?? null;

        this.Failed = values.Failed ?? 0;

        this.Status = values.Status ?? '';

        this.StatusCode = values.StatusCode ?? 'Info';

        this.Total = values.Total ?? 0;

        this.UserID = values.UserID ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"AverageTimePrItem": ${JSON.stringify(this.AverageTimePrItem)}` +
            ',' +
            `"Current": ${JSON.stringify(this.Current)}` +
            ',' +
            `"ElapsedTime": ${JSON.stringify(this.ElapsedTime)}` +
            ',' +
            `"Failed": ${JSON.stringify(this.Failed)}` +
            ',' +
            `"Status": ${JSON.stringify(this.Status)}` +
            ',' +
            `"StatusCode": ${this.StatusCode == 'Info' ? 0 : this.StatusCode == 'Warning' ? 1 : this.StatusCode == 'Error' ? 2 : this.StatusCode == 'Success' ? 3 : this.StatusCode == 'None' ? 4 : 0}` +
            ',' +
            `"Total": ${JSON.stringify(this.Total)}` +
            ',' +
            `"UserID": ${JSON.stringify(this.UserID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of StatusLoaderStatus from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {}): StatusLoaderStatus {
        return new StatusLoaderStatus(values);
    }

    public static _FromServerJson(json: any): StatusLoaderStatus {
        return new StatusLoaderStatus({
            AverageTimePrItem: json.AverageTimePrItem ?? null,
            Current: json.Current,
            ElapsedTime: json.ElapsedTime ?? null,
            Failed: json.Failed,
            Status: json.Status ?? '',
            StatusCode:
                json.StatusCode == 0
                    ? 'Info'
                    : json.StatusCode == 1
                      ? 'Warning'
                      : json.StatusCode == 2
                        ? 'Error'
                        : json.StatusCode == 3
                          ? 'Success'
                          : json.StatusCode == 4
                            ? 'None'
                            : 'Info',
            Total: json.Total,
            UserID: json.UserID,
        });
    }

    /**
     * Creates an instance of StatusLoaderStatus from another instance of StatusLoaderStatus.
     * @param other The StatusLoaderStatus you want to clone
     * @returns A cloned StatusLoaderStatus
     */
    public static FromOther(other: StatusLoaderStatus): StatusLoaderStatus {
        return StatusLoaderStatus._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return StatusLoaderStatus.FromOther(this);
    }

    static NAME_OF_CLASS = 'StatusLoaderStatus';
}
